import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';
import AdvForm from '../../../../CommonComponents/AdvForm';
import InputAutocomplete from '../../../InputAutocomplete/InputAutocompleteView';
import { yearValidator } from '../../LargePurchaseWorkflowValidators';

const ItemDescription = ({
  workflowId,
  branch,
  clientId,
  store,
  purchaseYear,
  purchaseYearOptions,
  onPostProcess,
  onPostSave,
  isNew,
  goal,
}) => (
  <AdvWorkflowStep branch={branch} workflowId={workflowId}>
    <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.DesiredPurchaseYear`} />

    <h2>When would you like to make the purchase?</h2>

    <AdvForm>
      <ul className="horizontal">
        <li>
          <InputAutocomplete
            isUnder
            isInteger
            inputmode="numeric"
            placeholder="Purchase Year"
            id="adv-purchase-year"
            className="lg text-center"
            value={purchaseYear}
            options={purchaseYearOptions}
            onChange={({ target: { value } }) => {
              const updates =
                value === 'At Retirement'
                  ? {
                      [BACKEND_KEY]: {
                        DesiredPurchaseYear: null,
                        PurchaseAtRetirement: true,
                      },
                    }
                  : {
                      [BACKEND_KEY]: {
                        DesiredPurchaseYear: value,
                        PurchaseAtRetirement: false,
                      },
                    };

              store(workflowId)(updates, clientId);
            }}
            showEmptyCustomMessage
            customEmptyMessage="Select Year"
          />
        </li>
      </ul>
    </AdvForm>

    <Navigation
      nextIterators={[]}
      dirtyGraphNodes={[]}
      validator={yearValidator(purchaseYear, purchaseYearOptions)}
      validationId={`${BACKEND_KEY}.DesiredPurchaseYear`}
      doNotSave={false}
      workflowId={workflowId}
      backendKey={BACKEND_KEY}
      onPostProcess={data => onPostProcess(data, goal)}
      onPostSave={onPostSave(isNew, workflowId, clientId)}
    />
  </AdvWorkflowStep>
);

ItemDescription.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  store: PropTypes.func.isRequired,
  purchaseYear: PropTypes.number.isRequired,
  purchaseYearOptions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  goal: PropTypes.shape().isRequired,
  onPostSave: PropTypes.func.isRequired,
  isNew: PropTypes.bool.isRequired,
};

export default ItemDescription;
